import React, { useState, useRef, useEffect } from "react"; 
import ReactPaginate from "react-paginate";
import {
    MdKeyboardArrowLeft,
    MdKeyboardArrowRight,
    MdCreate, 
    MdOutlineCircle, 
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import _constantUtil from "../../../utils/Constant"; 
import "react-datepicker/dist/react-datepicker.css";
import { Tooltip } from "react-tooltip"; 
import { TbCircleLetterBFilled } from "react-icons/tb";


function UpcomingMatch() { 
    const navigate = useNavigate();   
    const confirmationRef = useRef(_constantUtil.NULL); 
    const [confirmation , setConfirmation ] = useState(_constantUtil.BOOLEAN_FALSE)
    useEffect(() => {  
        const handleClickOutside = (event) => {
            if (
                confirmationRef.current &&
                !confirmationRef.current.contains(event.target)
            ) {
                setConfirmation(_constantUtil.BOOLEAN_FALSE);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
 
 
    return (
        <> 
           {confirmation && (
            <div>
                <div className='confirmation-overlay'></div>
                <div ref={confirmationRef} className='confirmation-dialog'>
                <p>Are you sure to update match status ?</p>
                <div className='d-flex justify-content-end '>
                    <button onClick={() => setConfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white p-2'>Cancel</button>
                    <button className='border-0 rounded px-3 bg-success text-white p-2 me-0' > Confirm  </button>
                </div>
                </div>
            </div>
            )} 

            <div className="px-4 ">
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="d-flex align-items-center justify-content-between ">
                            <h4 className="header-title pb-3 mt-4"> 
                                Launched Match
                            </h4> 
                        </div>
                        <div className="col-12  ">
                            <div className="card">
                                <div className="card-body">
                                    <input
                                        type="text"
                                        className="form-control search-width me-2 mb-2"
                                        id="search"
                                        name="search"
                                        placeholder="Search..."
                                        style={{ width: "15%" }} 
                                        autoComplete="off"
                                    />
                                    <div className="table-responsive">
                                        <table id="scroll-horizontal-datatable" className="table w-100 nowrap" >
                                            <thead>
                                                <tr>
                                                    <th>SN</th>
                                                    <th>Match Title</th>
                                                    <th className="text-nowrap">Tournament Name</th>
                                                    <th>Country</th>
                                                    <th className="text-nowrap">Date & Time</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>IND vs PAK <br /> (India vs Pakistan)</td>
                                                    <td>Premier League</td>
                                                    <td>Afghanistan</td>
                                                    <td>2024-10-02 <br />13:30:00</td>
                                                    <td>
                                                        <span className="badge badge-success-lighten">
                                                            ACTIVE
                                                        </span>
                                                    </td>
                                                    <td>
                                                    <TbCircleLetterBFilled
                                                        data-tooltip-id="view-bets" data-tooltip-content="View Bets" 
                                                        className="jumbo-icon pointer text-info user-status fs-4 me-2" style={{ cursor: "pointer" }} 
                                                        onClick={() => navigate(`/match/launch-bets`)}
                                                    />
                                                    <Tooltip id="view-bets" place="bottom" effect="solid" /> 

                                                    <MdCreate
                                                        data-tooltip-id="updatematch" data-tooltip-content="Update Match"
                                                        className="jumbo-icon fs-5 me-2" style={{ cursor: "pointer", color: "gray", }}
                                                        onClick={() => navigate( `/match/update-match`, { state : { Mcount : 2}} )}
                                                    />
                                                    <Tooltip border={ false } id="updatematch" place="bottom" effect="solid" />

                                                    <MdOutlineCircle
                                                        data-tooltip-id="active-match" data-tooltip-content="Active Match" 
                                                        className="jumbo-icon pointer text-success user-status fs-5 me-2" style={{ cursor: "pointer" }} 
                                                        onClick={()=>setConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                    />
                                                    <Tooltip id="active-match" place="bottom" effect="solid" />
                                                    </td>
                                                </tr> 
                                            </tbody>
                                        </table>
                                    </div>
                                    <ReactPaginate
                                        previousLabel={<MdKeyboardArrowLeft className="fs-4" /> }
                                        nextLabel={ <MdKeyboardArrowRight className="fs-4" /> }
                                        className="pagination"
                                        breakLabel={"..."}
                                        breakClassName={"break-me"} 
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5} 
                                        containerClassName={"pagination"}
                                        subContainerClassName={ "pages pagination" }
                                        activeClassName={"pagination-active-page" }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UpcomingMatch;
